<p-card title="Http {{error.status}}" subtitle="{{error.statusText}}" [style]="{width: '640px'}" styleClass="ui-card-shadow">
  <p-header>

  </p-header>
  <div>
    {{error.message}}
  </div>
  <p-footer>
    <a routerLink="/"><i class="fa fa-undo"></i> Back to Advanced Search and Reports</a>
  </p-footer>
</p-card>
